import type {MyWeatherEditorSections} from './sections';

/**
 * `keys` with `key` moved one step up (-1) or down (+1): the editor's Move up
 * and Move down, for the people who cannot drag. Past either end, or for a
 * key not in the list, a copy of `keys` as it is.
 */
export const moveKey = (
  keys: readonly string[],
  key: string,
  delta: -1 | 1,
): string[] => {
  const from = keys.indexOf(key);
  const to = from + delta;
  if (from < 0 || to < 0 || to >= keys.length) {
    return [...keys];
  }
  const next = [...keys];
  [next[from], next[to]] = [next[to], next[from]];
  return next;
};

/**
 * The station order the editor saves (`station_ids`), as it shows the
 * stations: yours, the retired ones of yours, then the favourite stations in
 * the Favorites order. The same stations as the cog screen sends: a hidden
 * station of yours that is also a favourite, at the end; never a station
 * viewed but not kept.
 */
export const editorStationIds = (
  {myStations, retired, favorites, hidden}: MyWeatherEditorSections,
  favoriteStationIds: readonly number[],
): number[] => [
  ...myStations.map((item) => item.station.id),
  ...retired.map((item) => item.station.id),
  ...favorites.flatMap((item) =>
    item.kind === 'station' ? [item.station.id] : [],
  ),
  ...hidden
    .map((item) => item.station.id)
    .filter((id) => favoriteStationIds.includes(id)),
];
